import React, { FC, ReactNode, useCallback, useMemo, useState } from "react";
import '../../styles/components/input.scss';
import { setClass } from "../../utils";
import { Cross, FilterIcon } from "../svgs";

type TInputVariant = 'square' | 'rounded' | 'bottom-line' | 'empty' | 'underlined' | 'default';

interface InputProps {
  variant: TInputVariant;
  value: string;
  disabled?: boolean;
  classes?: string;
  placeholder?: string;
  error?: boolean;
  label?: string;
  type?: string;
  startIcon?: ReactNode;
  maxLength?: number;
  filter?: boolean;
  endElement?: ReactNode;
  fastClearable?: boolean;
  autoFocus?: boolean;
  divClasses?: string;
  onChange?: (value: string) => void;
  onOpen?: () => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  filterRef?: React.MutableRefObject<HTMLInputElement>
}

export const Input: FC<InputProps> = ({
  value, disabled, classes, variant, placeholder, filter, fastClearable, onOpen, divClasses,
  label, error, type = 'text', startIcon, endElement, maxLength, onChange, autoFocus, onKeyDown, filterRef
}) => {

  const [isInputFocus, setIsInputFocus] = useState(false);

  //TODO: ПЕРЕНЕСТИ ВСЕ СТИЛИ ИНПУТА В input-box ЧТОБЫ НЕ ВЫСЧИТЫВАТЬ СЛЕВА/СПРАВА ПОСТОЯННО, А ОТДАТЬ НА ОТКУП flex

  const labelClassName = useMemo(() =>
    `label ${variant} ${error ? 'error' : ''} ${isInputFocus ? 'focus' : ''}`,
    [isInputFocus, error]);

  const onChangeFocus = useCallback(() => setIsInputFocus(prev => !prev), []);
  const clearInput = useCallback(() => onChange(''), []);

  const inputStyles = setClass(
    'input', variant, error && 'error', filter && fastClearable && 'two-elem',
    (filter != fastClearable) && 'one-elem', classes
  );

  const padding = filter ? '60px' : '40px';

  return (
    <div className={setClass("input-box", divClasses)} >
      {label && <label className={labelClassName}>{label}</label>}
      <div className="icon-with-input-wrapper" >
        {startIcon && <div className="start-icon">{startIcon}</div>}
        <input
          ref={filterRef}
          autoFocus={autoFocus}
          className={inputStyles}
          style={{ paddingLeft: startIcon && '50px', paddingRight: (fastClearable || endElement) && padding }}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          type={type}
          maxLength={maxLength}
          onChange={(event) => onChange(event.target.value)}
          onFocus={onChangeFocus}
          onBlur={onChangeFocus}
          onKeyDown={onKeyDown}
        />
        <div className="actions">
          {fastClearable && value.length > 0 &&
            <Cross
              divClassName="select-icon"
              onClick={clearInput}
            />
          }
          {filter &&
            <FilterIcon
              divClassName="select-icon"
              onClick={onOpen}
            />
          }
        </div>
        {endElement && endElement}
      </div>
    </div>
  );
};